import { scrollTo } from "../../common/scrollHelpers.js";
import { getScrollTop } from "../../common/scrollHelpers.js";

export default () => {
  document.querySelectorAll(".js-back-to-top").forEach((el) => {
    const main = document.querySelector("#main-content");

    if (!main) {
      return;
    }

    el.addEventListener("click", (e) => {
      e.preventDefault();
      scrollTo(0, () => {
        main.focus();
      });
    });

    window.addEventListener(
      "scroll",
      (e) => {
        const scrollPosition = getScrollTop();

        // if user scrolls is able to scroll on viewport, show button
        if (scrollPosition > 300) {
          el.classList.add("is-active");
        } else {
          el.classList.remove("is-active");
        }
      },
      { passive: true },
    );
  });
};
